<template>
  <div class="group">
    <FormLabel v-if="label" :text="label" :for-id="textareaId" :text-color-class="labelColorClass" :extra-class="labelClass" />
    <div class="relative">
      <textarea
        :id="textareaId"
        :value="modelValue"
        :placeholder="placeholder"
        :rows="rows"
        :disabled="disabled"
        :readonly="readonly"
        class="w-full bg-white border border-[#1c4848]/10 rounded-2xl px-4 py-3 text-sm font-medium text-[#1c4848] leading-relaxed focus:outline-none focus:border-[#1c4848]/30 focus:ring-4 focus:ring-[#1c4848]/5 shadow-sm resize-none transition-all placeholder-[#1c4848]/20"
        @input="$emit('update:modelValue', $event.target.value)"
      />
    </div>
  </div>
</template>

<script setup>
import FormLabel from '../Label.vue';

defineProps({
  modelValue: { type: String, default: '' },
  label: { type: String, default: '' },
  placeholder: { type: String, default: '' },
  rows: { type: [String, Number], default: 4 },
  textareaId: { type: String, default: '' },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  labelColorClass: { type: String, default: 'text-[#1c4848]/60' },
  labelClass: { type: String, default: '' }
});

defineEmits(['update:modelValue']);
</script>
